export default {
  "sizes": {
    "s": "18px",
    "m": "20px",
    "l": "25px"
  },

  "defaultScale": "m"
};
